module.exports = __webpack_public_path__ + "img/regular_lease_process04.afcc9332.png";